








































import { Component, Vue } from 'vue-property-decorator'
import { IWeboffice, IWebofficeCreateForm } from '@/apps/open/types/weboffice'
import { getWebofficeList, applyWeboffice, updateWebofficeInfo } from '@/apps/open/services/weboffice'
import EditAppDialogBody from '@/apps/open/components/DialogBodys/weboffice/EditApp.vue'

@Component
export default class List extends Vue {
  data: IWeboffice[] = []
  submitting = true
  loading = false
  applyDialogVisible = false

  get curEnterprise () {
    return this.$store.getters['User/curEnterprise']
  }

  created () {
    this.getAppList()
    this.initEventListener()
  }

  async getAppList () {
    this.loading = true
    try {
      const params = {
        developer_id: this.curEnterprise.developer_id
      }
      const resp = await getWebofficeList(params)
      const data = resp.data as any
      this.data = data.data || [] as IWeboffice[]
    } catch (error) {
      this.$message.error(error.message)
    }
    this.loading = false
  }

  initEventListener () {
    this.$eventBus.$on('changeEnterprise', this.getAppList)
  }

  beforeDestroy () {
    this.$eventBus.$clear('changeEnterprise', this.getAppList)
  }

  showEditDialog (appInfo: IWebofficeCreateForm) {
    const isEdit = !!appInfo
    this.$dialog.show({
      title: isEdit ? '编辑应用' : '申请应用',
      body: EditAppDialogBody,
      bodyProps: {
        data: appInfo,
        submit: this.apply
      },
      buttons: [
        { text: '取消' },
        { text: '确定', type: 'primary', event: 'onOk' }
      ]
    })
  }

  async apply (appInfo: IWebofficeCreateForm) {
    try {
      const urlParams = {
        developer_id: this.curEnterprise.developer_id
      }
      if (appInfo.app_id) {
        const resp = await updateWebofficeInfo(appInfo.app_id, appInfo, urlParams)
        const data = resp.data as IWeboffice
        const currentData = this.data.find((item: IWeboffice) => item.app_id === data.app_id) as IWeboffice
        currentData.app_name = data.app_name
        currentData.website = data.website
        currentData.description = data.description
      } else {
        const resp = await applyWeboffice(appInfo, urlParams)
        const data = resp.data as IWeboffice
        this.data.push(data)
      }
      this.$message('申请已提交，请您耐心等待')
    } catch (error) {
      this.$message.error(error.message)
    }
    this.$dialog.close()
  }
}
